import React, { Component } from "react";
import DeleteDialog from "../../components/DeleteDialog";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { languages } from "../../constants/languages";

class DeleteQuestionContainer extends Component {
  state = {
    open: false
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  handleDelete = () => {
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    let questions = this.props.tournament.questions || {};

    delete questions[this.props.questionId];

    let toUpdate = {};

    toUpdate["questions"] = questions;

    tournamentRef.update(toUpdate);
  };

  render() {
    return (
      <div>
        <IconButton
          aria-label="Change"
          onClick={this.toggleDialog}
          disabled={this.props.disabled}
          style={{ height: 30, width: 30 }}
        >
          <DeleteIcon
            style={{ height: 20, width: 20, position: "absolute", top: 5 }}
          />
        </IconButton>
        <DeleteDialog
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          handleDelete={this.handleDelete}
          errorMessage={this.state.errorMessage}
          title={languages.signupPage.deleteQuestion}
          description={languages.signupPage.deleteQuestionWarning}
        />
      </div>
    );
  }
}

export default DeleteQuestionContainer;
